// extracted by css-extract-rspack-plugin
export default {"BorderedButton":"sUOIp","SettingsButton":"umLpY","VisualizationButton":"kIHkd"};